//格式化时间
function formateDate(date) {
  let getTime = new Date(date).getTime(); //获取中国时间戳
  let d = new Date(getTime).getDate() > 9 ? new Date(getTime).getDate() : '0' + new Date(getTime).getDate();
  let m = (new Date(getTime).getMonth() + 1) > 9 ? new Date(getTime).getMonth() + 1 : '0' + (new Date(getTime).getMonth() + 1);
  let y = new Date(getTime).getFullYear();
  return y + '-' + m + '-' + d;
}
// 获取本季度的第一天
function getFirstDayOfQuarter() {
  let now = new Date().getTime() //获取中国时间戳
  now = now - 16 * 3600 * 1000
  now = new Date(now);
  const quarter = Math.floor((now.getMonth() / 3));
  const firstDay = new Date(now.getFullYear(), quarter * 3, 1);
  return firstDay;
}
// 获取本季度的最后一天
function getLastDayOfQuarter() {
  let now = new Date().getTime() //获取中国时间戳
  now = now - 16 * 3600 * 1000
  now = new Date(now);
  const quarter = Math.floor((now.getMonth() / 3));
  const lastDay = new Date(now.getFullYear(), (quarter + 1) * 3, 0);
  return lastDay;
}
//获取本周第一天和最后一天
function getWeekDates() {
  // 获取当前日期
  let now = new Date().getTime() //获取中国时间戳
  now = now - 16 * 3600 * 1000
  var today = new Date(now);
  // 获取当前是星期几
  var day = today.getDay();
  // 计算本周第一天的日期
  var startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - day);
  // 计算本周最后一天的日期
  var endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - day + 6);
  // 返回本周的日期范围
  return { start: startDate, end: endDate };
}
//获取本月第一天个最后一天
function getFirstAndLastDayOfMonth() {
  // 获取当前日期
  let currentDate = new Date(); // 获取当前日期
  currentDate.setTime(currentDate.getTime() - 16 * 3600 * 1000); // 减去16小时
  
  currentDate.setDate(1); // 设置日期为当前月的第一天
  var firstDay = currentDate.toISOString().slice(0, 10);
  currentDate.setMonth(currentDate.getMonth() + 1); // 设置日期为下个月的第一天
  currentDate.setDate(0); // 将日期设置为上个月的最后一天
  var lastDay = currentDate.toISOString().slice(0, 10);
  
  return {
    firstDay: firstDay,
    lastDay: lastDay
  };
}
//当前指定日期间的所有日期
function getDatesBetween(startDate, endDate) {
  var dates = [];
  var currentDate = new Date(startDate);
  var endDateTime = new Date(endDate);
  
  // 循环从开始日期到结束日期之间的每一天
  while (currentDate <= endDateTime) {
    var formattedDate = currentDate.getFullYear() + "-" + ((currentDate.getMonth() + 1) > 9 ? (currentDate.getMonth() + 1) : '0' + (currentDate.getMonth() + 1)) + "-" + (currentDate.getDate() > 9 ? currentDate.getDate() : '0' + currentDate.getDate());
    dates.push(formattedDate);

    // 将当前日期加一天
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

function generateTimeArray() {
  const timeArray = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute++) {
      const hourString = hour.toString().padStart(2, '0');
      const minuteString = minute.toString().padStart(2, '0');
      const timeString = `${hourString}:${minuteString}`;
      timeArray.push(timeString);
    }
  }
  return timeArray;
}

function formateDateLong(date) {
  // 创建一个Date对象
  var date = new Date(date);

  // 获取世界时间的年、月、日、时、分、秒
  var year = date.getUTCFullYear();
  var month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  var day = date.getUTCDate().toString().padStart(2, '0');
  var hours = date.getUTCHours().toString().padStart(2, '0');
  var minutes = date.getUTCMinutes().toString().padStart(2, '0');
  var seconds = date.getUTCSeconds().toString().padStart(2, '0');

  // 格式化时间字符串
  var formattedTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

  // 输出格式化后的时间
  return formattedTime;
}

function getTimeInterVal(startDate, endDate) {
  var start = new Date(startDate).getTime();
  var end = new Date(endDate).getTime();
  start = start - 16 * 3600 * 1000;
  end = end - 16 * 3600 * 1000;
  var timeDiff = Math.abs(end - start);

  var oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
  var oneWeek = 7 * oneDay; // 一周的毫秒数
  var oneMonth = 30 * oneDay; // 一个月的毫秒数
  var oneQuarter = 3 * oneMonth; // 一个季度的毫秒数
  if (timeDiff <= oneDay) {
    console.log("oneDay");
    return "oneDay";
  } else if (timeDiff <= oneWeek) {
    console.log("oneWeek");
    return "oneWeek";
  } else if (timeDiff <= oneMonth) {
    console.log("oneMonth");
    return "oneMonth";
  } else if (timeDiff <= oneQuarter) {
    console.log("oneQuarter");
    return "oneQuarter";
  } else {
    return "超过一个季度";
  }
}

function analysisUrl(url) {
  // 使用正则表达式提取域名部分
  const domain = url.match(/^(.*?)(?=\?)/)[0];

  // 将链接中的参数部分提取出来
  const paramsString = url.replace(domain + '?', '');
  const params = paramsString.split('&');

  // 创建一个对象来存储键值对，包括域名
  const keyValuePairs = {
    domain: domain
  };

  // 遍历每个参数，分割键和值，并存储在对象中
  params.forEach(param => {
    const [key, value] = param.split('=');
    keyValuePairs[key] = decodeURIComponent(value);
  });

  return keyValuePairs;
}
function getPre15date(date){
   // 获取当前日期
   let currentDate = new Date(date);

   // 获取当前日期前15天的日期
   let pastDate = new Date(currentDate);
   pastDate.setDate(currentDate.getDate() - 15);
 
   // 检查是否跨月，如果跨月则返回当月的第一天
   if (pastDate.getMonth() !== currentDate.getMonth()) {
     pastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
   }
 
   // 将日期格式化为 YYYY-MM-DD
   let formattedDate = pastDate.toISOString().slice(0, 10);
   return formattedDate;
}
export { 
  formateDate, 
  getFirstDayOfQuarter, 
  getWeekDates, 
  getFirstAndLastDayOfMonth, 
  getLastDayOfQuarter, 
  getDatesBetween, 
  generateTimeArray, 
  formateDateLong, 
  getTimeInterVal, 
  analysisUrl ,
  getPre15date
}



// WEBPACK FOOTER //
// ./src/assets/dateUtils.js